export enum SiteVariantEnum {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
  TextOnly = 'TextOnly',
}

export type SiteVariantType = keyof typeof SiteVariantEnum;
